import { styled } from 'styled-components';

import { COLORS, SHADOWS } from '@components/web/src/styles';

export const ProductRateListItemContainer = styled.button<{
  $isActive: boolean;
  $backgroundColor: string;
  $borderColor: string;
}>`
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
  padding: 12px 12px 12px 20px;
  border-radius: 10px;
  border: 1px solid ${({ $isActive, $borderColor }) => ($isActive ? $borderColor : COLORS.gray[100])};
  background-color: ${({ $isActive, $backgroundColor }) => ($isActive ? $backgroundColor : COLORS.gray[25])};
  box-shadow: ${({ $isActive }) => ($isActive ? SHADOWS.md : 'none')};
  cursor: pointer;
`;
